import useTableLayout from "../../hooks/useTableLayout";
import Pagination from "../common/utils/Pagination";
import filter, {useFilterContext} from "../../contexts/filter";
import {useEffect, useState} from "react";
import {Flex} from "../../styles/MarketStyles";
import {ScaleLoader} from "react-spinners";
import NoData from "../common/utils/NoData";


const RTableLayout = ({
    data,
    hasPagination = true,
    children
}) => {

    const { data: _data, loading } = data
    const TOTAL = _data?.meta?.total ? _data?.meta.total : 0

    const initialHeight = 'calc(100% - 140px)'
    const [ height, setHeight ] = useState(initialHeight)

    const { filters, cache } = useFilterContext()


    useEffect(() => {
        const _filter = filters[cache]
        if (_filter) {
            const filter = Object.keys(_filter)
            if (filter.length) setHeight('calc(100% - 210px)')
            else setHeight(initialHeight)
        }
    }, [filters, cache])

    const {
        pagination,
        onPageChange,
        onLimitChange
    } = useTableLayout()

    return (
        <>
            <div style={{ height: height, minHeight: '240px', overflow: "auto" }}>
                {loading ?
                    <Flex fw style={{ marginTop: '80px' }}>
                        <ScaleLoader
                            height={26}
                            width={3}
                            color="#599eff"
                        />
                    </Flex>
                    // <Skeleton
                    //     Content={RListSkeleton}
                    //     count={5}
                    // />
                    : (
                        (data?.data && !data?.data?.data?.length) ?
                            <NoData />
                            :
                            children
                    )
                }
            </div>
            {hasPagination &&
                <Pagination
                    total={TOTAL}
                    page={pagination?.page}
                    limit={pagination?.limit}
                    onPageChange={onPageChange}
                    onLimitChange={onLimitChange}
                />
            }

        </>
    )
}

export default RTableLayout
